import { Route, Routes } from 'react-router-dom'
import NotFound from 'routes/NotFound'
import Page from 'components/global/Page'
import { useApp } from 'store/steps'
import FailedPage from './routes/FailedPage'
import RegistrationConfirmation from 'routes/RegistrationConfirmation'
import AccountActivated from 'routes/AccountActivated'
import ActivationLinkInvalid from 'routes/ActivationLinkInvalid'
import ActivationLinkExpired from 'routes/ActivationLinkExpired'
import PaymentConfirmation from 'routes/PaymentConfirmation'

const GlobalPages = () => {
    const { appMode, getPath } = useApp()

    return (
        <Page>
            <Routes>
                <Route
                    path={getPath('registration_confirmation')}
                    element={<RegistrationConfirmation />}
                />
                <Route
                    path={getPath('activation_link_invalid')}
                    element={<ActivationLinkInvalid />}
                />
                <Route
                    path={getPath('activation_link_expired')}
                    element={<ActivationLinkExpired />}
                />
                <Route
                    path={getPath('account_active')}
                    element={<AccountActivated />}
                />
                <Route
                    path={getPath('payment_failed')}
                    element={<FailedPage />}
                />
                <Route
                    path={getPath('payment')}
                    element={<PaymentConfirmation />}
                />
                {appMode && <Route path="*" element={<NotFound />} />}
            </Routes>
        </Page>
    )
}

export default GlobalPages
